import { useEffect, useRef } from 'react';
import { Link } from 'react-router';
import { BadgeCheck } from 'lucide-react';
import { secondaryButtonClass } from '@/shared/ui/formClasses';

/** La conferma dopo l'invio, con il riepilogo di ciò che è stato inviato. */
export default function DemoRequestSubmitted({ summary }) {
  const titleRef = useRef(null);

  // Il modulo sparisce con il fuoco: lo riceve il titolo della conferma.
  useEffect(() => {
    titleRef.current.focus();
  }, []);

  return (
    <div className="grid gap-8 lg:grid-cols-[1.05fr_0.95fr]">
      <section className="rounded-hero border border-default bg-default p-8 shadow-resting">
        <p className="inline-flex items-center gap-1.5 rounded-full border border-success-muted bg-success-subtle px-2.5 py-1 text-badge text-success">
          <BadgeCheck aria-hidden className="size-3.5" />
          Inviata
        </p>
        <h1
          ref={titleRef}
          tabIndex={-1}
          className="mt-6 text-page-title text-strong outline-hidden"
        >
          Richiesta registrata
        </h1>
        <p className="mt-5 max-w-2xl text-body-lg text-muted">
          Ti contatteremo per organizzare la demo.
        </p>
        <Link to="/" className={`mt-8 ${secondaryButtonClass}`}>
          Torna alla home
        </Link>
      </section>

      <section
        aria-labelledby="demo-summary"
        className="rounded-hero border border-default bg-subtle p-8 shadow-resting"
      >
        <h2 id="demo-summary" className="text-kpi-label text-subtle">
          Riepilogo raccolto
        </h2>
        <dl className="mt-6 space-y-3">
          {summary.map(([label, value]) => (
            <div
              key={label}
              className="rounded-xl border border-default bg-default px-4 py-3 shadow-resting"
            >
              <dt className="text-kpi-label text-subtle">{label}</dt>
              <dd className="mt-2 text-sm text-strong">{value}</dd>
            </div>
          ))}
        </dl>
      </section>
    </div>
  );
}
